/* eslint-disable camelcase */
import { Component } from 'preact';
import PropTypes from 'prop-types';
import {
  resetList,
  setTotalPages,
  setPerPage,
} from '../../stores/SearchFilter';
import List from './List';

class ListApp extends Component {
  constructor(props) {
    super(props);

    const { list, total_pages, per_page } = this.props;

    this.state = {
      list: list || [],
      loading: false,
      loadingMore: false,
      page: 1,
      total_pages: total_pages || 0,
      hasInitialData: !!list && list.length > 0,
    };

    if (per_page) {
      setPerPage(per_page);
    }
    setTotalPages(total_pages);
    resetList(list);

    window.store.SearchFilter.watch(state => {
      this.setState(prevState => ({
        list: state.list,
        loading: state.loading,
        loadingMore: state.loadingMore,
        page: state.page,
        total_pages: state.total_pages,
        hasInitialData: state.loadInitial || prevState.hasInitialData,
      }));
    });
  }

  showLoadMore() {
    const { total_pages, page, loadingMore } = this.state;
    return total_pages > page || loadingMore;
  }

  // eslint-disable-next-line consistent-return
  render() {
    const { list, loading, loadingMore, hasInitialData } = this.state;
    const { part_link, showBrand, cardsPerLine, cardTitleOnHeader } =
      this.props;

    if (list.length > 0) {
      return (
        <List
          items={list}
          loading={loading}
          loadingMore={loadingMore}
          showLoadMore={this.showLoadMore()}
          part_link={part_link}
          showBrand={showBrand}
          cardsPerLine={cardsPerLine}
          ctaInterestButtonText={this.props.ctaInterestButtonText}
          cardTitleOnHeader={cardTitleOnHeader}
        />
      );
    }

    if (hasInitialData && (!list || list.length === 0)) {
      return (
        <div
          className="container alert alert-warning card-info mt-4"
          role="alert"
        >
          Não há consórcios disponíveis.
        </div>
      );
    }

    return (
      <ul className="row list-consortia__list-placeholder">
        {[1, 2, 3].map(item => (
          <li key={item} className="list-consortia__item">
            <div className="ph-item" style={{ width: '100%' }}>
              <div className="ph-col-12">
                <span className="ph-picture" />
                <div className="ph-row">
                  <div className="ph-col-2 empty" />
                  <div className="ph-col-8 big" />
                  <div className="ph-col-2 empty" />
                </div>
                <div className="ph-row card__box-offer-placeholder">
                  <div className="ph-col-10" />
                  <div className="ph-col-4 empty" />
                  <div className="ph-col-4 big" />
                  <div className="ph-col-4 empty" />
                  <div className="ph-col-6" />
                </div>
                <div className="ph-row card__box-offer-placeholder">
                  <div className="ph-col-10" />
                  <div className="ph-col-4 empty" />
                  <div className="ph-col-4 big" />
                  <div className="ph-col-4 empty" />
                  <div className="ph-col-6" />
                </div>
                <div className="ph-row">
                  <span className="ph-col-12 list-consortia__button-placeholder-item" />
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  }
}

ListApp.defaultProps = {
  list: [],
  cardTitleOnHeader: false,
  cardsPerLine: 3,
  ctaInterestButtonText: 'Estou Interessado',
};

ListApp.propTypes = {
  list: PropTypes.arrayOf,
  total_pages: PropTypes.number.isRequired,
  per_page: PropTypes.number.isRequired,
  part_link: PropTypes.string.isRequired,
  showBrand: PropTypes.number.isRequired,
  ctaInterestButtonText: PropTypes.string,
  cardTitleOnHeader: PropTypes.bool,
  cardsPerLine: PropTypes.number,
};

export default ListApp;
